import { createColumnsExportService } from "./factory";

export const columnsExportService = createColumnsExportService();
